import React from 'react'
import BasicModalWindow from '../../components/BasicModalWIndow'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { useDispatch } from 'react-redux'
import { updateContainerId, updateOpenContainedItemsStatus } from './itemsSlice'
import ContainerItems from './ContainerItems'

export default function ContainerItemsModal() {

    const dispatch = useDispatch()

    const { containerId, openContainedItems } = useSelector((state: RootState) => state.items)

    /**
     * Handle close modal
     */
    const handleCloseModal = () => {
        dispatch(updateOpenContainedItemsStatus(false))
        dispatch(updateContainerId(null))
    }

    return(
        <BasicModalWindow
            shown={openContainedItems}
            title="Container Items"
            handleClose={handleCloseModal}
            size="lg"
            actionButtons={[]}
        >
            <div></div>
            {containerId ? <ContainerItems itemId={containerId} onlyShowItems /> : <></>}
        </BasicModalWindow>
    )

}